/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrderResponse } from '../models/CreateOrderResponse';
import type { PartAvailabilitySumbitModel } from '../models/PartAvailabilitySumbitModel';
import type { PartLookUpResult } from '../models/PartLookUpResult';
import type { PartOrderCard } from '../models/PartOrderCard';
import type { PartRequestAddressInputModel } from '../models/PartRequestAddressInputModel';
import type { PartRequestCustomerInfo } from '../models/PartRequestCustomerInfo';
import type { PartRequestModel } from '../models/PartRequestModel';
import type { PartRequestType } from '../models/PartRequestType';
import type { PartRequestWipInfoInputModel } from '../models/PartRequestWipInfoInputModel';
import type { Titles } from '../models/Titles';
import type { WipInfoModel } from '../models/WipInfoModel';
import type { WipInfosInput } from '../models/WipInfosInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PartRequestService {

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postSavePartReqest(
formData?: {
'Customer.Title'?: string;
'Customer.TitleId'?: Titles;
'Customer.FirstName': string;
'Customer.LastName': string;
'Customer.Email': string;
'Customer.Phone': string;
'Customer.CDKCustomerId'?: string;
'Customer.FullName'?: string;
Description?: string;
RegNo: string;
BranchId?: number;
BranchCode?: string;
Id?: number;
Wip?: number;
Type?: PartRequestType;
ConcernType?: number;
SoHeaderId?: number;
TechnicianRepairId?: number;
SendEmailSMS?: boolean;
PhotosInputModels?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SavePartReqest',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param partRequestId 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postSavePartRequestWithNoPayment(
partRequestId?: number,
requestBody?: Array<WipInfosInput>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SavePartRequestWithNoPayment',
      query: {
        'partRequestId': partRequestId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSaveApplyPartRequestAddress(
requestBody?: PartRequestAddressInputModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveApplyPartRequestAddress',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns WipInfoModel Success
   * @throws ApiError
   */
  public static getGetPartRequests(
id?: number,
): CancelablePromise<Array<WipInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequests',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param partRequestId 
   * @param userId 
   * @param allParts 
   * @returns CreateOrderResponse Created
   * @throws ApiError
   */
  public static postCreateOrderCdk(
partRequestId?: number,
userId?: number,
allParts: boolean = false,
): CancelablePromise<CreateOrderResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateOrderCDK',
      query: {
        'partRequestId': partRequestId,
        'userId': userId,
        'allParts': allParts,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WipInfoModel Success
   * @throws ApiError
   */
  public static getGetPartRequest(
id?: number,
): CancelablePromise<Array<WipInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequest',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wips 
   * @returns PartOrderCard Success
   * @throws ApiError
   */
  public static getGetPartOrderCart(
wips?: Array<number>,
): CancelablePromise<PartOrderCard> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartOrderCart',
      query: {
        'wips': wips,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param brandCode 
   * @param partNumber 
   * @returns PartLookUpResult Success
   * @throws ApiError
   */
  public static getPartRequestsPartsLookup(
brandCode?: string,
partNumber?: string,
): CancelablePromise<PartLookUpResult[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-requests/parts/lookup',
      query: {
        'brandCode': brandCode,
        'partNumber': partNumber,
      },
    });
  }

  /**
   * @param partRequestId 
   * @returns PartRequestModel Success
   * @throws ApiError
   */
  public static getGetPartEnquiry(
partRequestId?: number,
): CancelablePromise<PartRequestModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartEnquiry',
      query: {
        'partRequestId': partRequestId,
      },
    });
  }

  /**
   * @param partRequestId 
   * @returns PartRequestCustomerInfo Success
   * @throws ApiError
   */
  public static getGetPartRequestCustomerInfo(
partRequestId?: number,
): CancelablePromise<PartRequestCustomerInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequestCustomerInfo',
      query: {
        'partRequestId': partRequestId,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchPartRequestWipInfo(
id: number,
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/PartRequest/{id}/wip-info',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postWipInfo(
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-info',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postPartsAvailability(
id: number,
requestBody?: PartAvailabilitySumbitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/parts/{id}/availability',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
